export function getSafeReturnTo(value: string | null): string {
    if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\') || value.includes('#') || /[\u0000-\u001f]/.test(value)) {
        return '/dashboard';
    }

    return value;
}
